var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgQuoteTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.09081H21.4444H20.1667C19.4639 6.09081 18.8889 5.51809 18.8889 4.8181V1L24 6.09081Z",
    fill: "#D8D8D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19458 4.81824H10.5834",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19458 7.36353H5.47235",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.36353H8.02777",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 29.0002C23.9998 29.7001 23.4248 30.2729 22.722 30.2729H2.27777C1.575 30.2729 1 29.7001 1 29.0002V2.27343C1 1.57345 1.575 1.00073 2.27777 1.00073H18.8887L23.9998 6.09154V29.0002Z",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4444 6.09081H20.1667C19.4639 6.09081 18.8889 5.51809 18.8889 4.8181V1",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30547 11.181V13.7264C9.30547 14.4264 8.73047 14.9991 8.0277 14.9991H5.47217L9.30547 11.181Z",
    fill: "#D8D8D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3056 11.1814V13.7268C9.3056 14.4268 8.7306 14.9995 8.02783 14.9995",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47205 15.0002V25.1818C5.47205 25.8818 6.04704 26.4545 6.74981 26.4545H18.2497C18.9525 26.4545 19.5275 25.8818 19.5275 25.1818V12.4548C19.5275 11.7548 18.9525 11.1821 18.2497 11.1821H9.30535L5.47205 15.0002Z",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 19.454H16.3332",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 22.6354H16.3332",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.139 16.2726H16.3335",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteTemplate);
export default __webpack_public_path__ + "static/media/quote-template.366f02dd35ac0b53f66991cee2cdff45.svg";
export { ForwardRef as ReactComponent };